export default class matchHeight {
  init() {
    this.loghandler();
  }
  loghandler() {
    $('.js-match_height').matchHeight({
      byRow: false
    });
    $('.js-match_height_row').matchHeight();
    $('.p-products_purpose .c-tab_card_body_title').matchHeight();
    $('.p-products_purpose_logo').matchHeight();
    $('.c-card_primary_logo').matchHeight();
    $('.c-card_primary_title, .c-card_secondary_title, .c-card_tertiary_title').matchHeight();
    $('.c-card_primary_text, .c-card_secondary_text, .c-card_tertiary_text').matchHeight();
    $('.p-business_category_bottom_list').matchHeight();
  }
}


// WEBPACK FOOTER //
// ./src/assets/js/modules/match_height.js